"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSupplyLabel = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const i18n_1 = require("@completeanatomy/i18n");
function getSupplyLabel(type, t, names) {
    let supplyLabel = '';
    switch (type) {
        case bridge_schema_1.InfoBoxTabType.Innervation:
            if (names && names.length > 1) {
                supplyLabel = t(i18n_1.Strings.infoBox.innervatingNerves);
                break;
            }
            else {
                supplyLabel = t(i18n_1.Strings.infoBox.innervatingNerve);
                break;
            }
        case bridge_schema_1.InfoBoxTabType.ArterialSupply:
            supplyLabel = t(i18n_1.Strings.infoBox.arterialSupply);
            break;
        default:
            break;
    }
    return supplyLabel;
}
exports.getSupplyLabel = getSupplyLabel;
